/**
 * Client-side blackout window check.
 * Matches the server-side blackout window in blackout_check.go:
 *   3:30 PM – 4:00 PM EST (America/New_York)
 */

const BLACKOUT_START_MINUTES = 15 * 60 + 30; // 15:30 = 930 min
const BLACKOUT_END_MINUTES = 16 * 60;        // 16:00 = 960 min

export function isBlackoutWindow(): boolean {
  const now = new Date();
  const estStr = now.toLocaleString("en-US", { timeZone: "America/New_York" });
  const est = new Date(estStr);
  const totalMinutes = est.getHours() * 60 + est.getMinutes();
  return totalMinutes >= BLACKOUT_START_MINUTES && totalMinutes < BLACKOUT_END_MINUTES;
}

export function getBlackoutMessage(): string {
  return "Portfolio analysis is unavailable from 3:30–4:00 PM EST. This window is reserved for live trade execution.";
}
